import { useTranslation } from 'react-i18next';
interface IProp {
    selectedData: any;
    listName: string;
}

const DetailInfoPartToList: React.FC<IProp> = ({ selectedData, listName }) => {

    const { t } = useTranslation();

    return (
        <div>

            <h4 className="fw-bold my-1">{selectedData.length > 1 ? t('xref-these-product-has-been-added-to-your-list') : t('xref-this-product-have-been-added-to-your-list')} </h4>

            <h4 className="fw-bold pb-0"> {t('xref-tbl-hd-mrf-part')} </h4>
            {selectedData && selectedData.length > 0 &&
                selectedData.map((sData: any) => (
                    <div key={sData.masterPartId}>
                        <span className="mt-1">{sData.manufacturerProductNumber}</span>
                    </div>
                ))}

            <div className="mt-2 mb-4">
                <h4 className="fw-bold pb-0">{t('xref-list-name')}</h4>
                <div>
                    {listName}
                </div>
            </div>
            
        </div>
    )
}

export default DetailInfoPartToList;